import Vue from 'vue';
// Vue全局事件  事件公交车
// eventBus.$emit("name",params);
// eventBus.$on("name",(params)=>{
// })
export default new Vue();
